module.exports = __webpack_public_path__ + "static/media/pinkext.d705fc82.svg";